import { call, put, select, takeLatest } from 'redux-saga/effects';
import { ActionMeta } from 'redux-actions';
import { FetchResult } from 'apollo-boost';

import { SAVE_SERVICES, saveServices, SET_SERVICES_WITH_SAVE, setServices, SaveServicesMeta } from './actions';
import { SelectedServicesState } from './reducers';
import { getSelectedServices } from './selectors';

import {
	CheckinSaveOrderServicesMutation,
	CheckinSaveOrderServicesMutationVariables,
	CheckinSaveOrderServicesDocument,
	OrderSelectedServices,
	GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment
} from '@websky/graphql';
import { createClient } from '../../../../graphql-client';
import { getBaggageServices, getCheckinOrderId } from '../order/selectors';
import { fillCheckinOrder } from '../order/actions';
import { createServicesForRequest } from '../../utils';
import { setLoadingOff, setLoadingOn } from '../servicesLoading/actions';
import { Action } from 'redux-actions';
import { ServicePayload } from '../../../../Checkout/store/selectedServices/actions';

function runRequest(services: OrderSelectedServices) {
	const client = createClient();

	return client.mutate<CheckinSaveOrderServicesMutation, CheckinSaveOrderServicesMutationVariables>({
		mutation: CheckinSaveOrderServicesDocument,
		variables: {
			params: services
		}
	});
}

function* setServicesWithSave({ payload }: Action<ServicePayload[]>) {
	yield put(setServices(payload));
	yield put(saveServices());
}

function* saveServicesWorker(action: ActionMeta<void, SaveServicesMeta>) {
	const orderId: string = yield select(getCheckinOrderId);
	const selectedServices: SelectedServicesState = yield select(getSelectedServices);
	const baggageServices: GdsService_OrderAdditionalServiceGdsServiceBaggage_Fragment[] = yield select(
		getBaggageServices
	);
	yield put(setLoadingOn());

	const { data, errors }: FetchResult<CheckinSaveOrderServicesMutation> = yield call(runRequest, {
		id: orderId,
		services: createServicesForRequest(selectedServices, baggageServices)
	});

	if (errors) {
		yield put(setLoadingOff());
		throw errors;
	} else if (data?.CheckinSaveOrderServices) {
		yield put(fillCheckinOrder(data.CheckinSaveOrderServices));
		yield put(setLoadingOff());

		action.meta?.resolve?.(data.CheckinSaveOrderServices);
	}
}

export function* saveServicesSaga() {
	yield takeLatest(SET_SERVICES_WITH_SAVE, setServicesWithSave);
	yield takeLatest(SAVE_SERVICES, saveServicesWorker);
}
